"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { Typography } from "@/components/shared/Typography";
import CustomImage from "../shared/CustomImage";
import { getNewsDetailsUrl } from "@/utils/getNewsDetailsUrl";
import { ArticleListType } from "@/types/article";
import { getImageUrl } from "@/utils/getImageUrl";
import TitleTag from "../shared/TitleTag";
import { getLocaleFromPathname } from "@/utils/getLocaleFromPath";
import { DEFAULT_LANGUAGE } from "@/data/constants";

interface TextOverArticleCardProps {
  article: ArticleListType;
}

const TextOverArticleCard = ({ article }: TextOverArticleCardProps) => {
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname);

  if (!article) return <></>;

  const { title, slug, image, categoryId, subCategoryId, isLiveNews, isInPrint, publishedAt } = article;

  return (
    <Link
      href={getNewsDetailsUrl(categoryId, subCategoryId, slug, locale)}
      aria-label={`View news: ${title}`}
    >
      <div className="relative w-full overflow-hidden rounded-md aspect-video group">
        <CustomImage
          src={getImageUrl(image?.sizes?.ld?.filename || image?.filename)}
          className={`object-cover object-${article.focusPosition} w-full h-full img-zoom-hover`}
          alt={image?.alt || ""}
        />
        <div className="absolute top-0 left-0 w-full h-full rounded-md bg-gradient-to-b from-transparent to-black"></div>
        <div className="absolute bottom-4 inset-x-4">
          <Typography language={DEFAULT_LANGUAGE} variant="h5" className={"line-clamp-2 "} color="#fff">
            {isLiveNews &&
              publishedAt &&
              Date.now() - new Date(publishedAt).getTime() <= 12 * 60 * 60 * 1000 && (
                <TitleTag labelKey="LIVE_NEWS" />
              )}
            {isInPrint && <TitleTag labelKey="PRINT_EDITION" />}
            {title}
          </Typography>
        </div>
      </div>
    </Link>
  );
};

export default TextOverArticleCard;
